import React, { Component } from 'react';
const iconMenu = require('../../../../public/img/miami/ui/icon-menu.svg');
const iconMenuPrimary = require('../../../../public/img/miami/ui/icon-menu-primary.svg');

class MenuButtonMiami extends Component {

  renderBackButton = () => {
    let icon = iconMenu;
    let textColor = "#95268e";
    if (this.props.colorPallette === "adaptive") {
      textColor = "#006699";
      icon = iconMenuPrimary;
    }
    return (
      <div>
        <div style={{ position: "absolute", marginLeft: '.3vh', top: 0, height: "2vh", width: "100%" }}>
          <span style={{ position: "absolute", top: "1.2vh", fontSize: '.96vh', color: textColor, right: "0.65104166666666666667vh" }}>MENU</span>
        </div>
        <div style={{ position: "absolute", top: "2.5vh", marginLeft: '.3vh', marginTop: "0.5vh", width: "100%", height: "2vh" }}>
          <img className="fliph" alt="back" style={{ position: "absolute", width: '2vh', height: '1.2vh', marginLeft: "0.208333333vh", right: "1.04166666666666666667vh" }} src={icon} />
        </div>
      </div>
    )
  }

  render() {
    return (
      <div>
        {this.props.mode === "video" ?
          <div onMouseDown={() => this.props.clickAction()} style={{ position: 'fixed', height: this.props.height, width: this.props.width, top: this.props.top, borderRadius: this.props.border, left: this.props.left }}>
            {this.renderBackButton()}
          </div>
          :
          <div onMouseDown={() => this.props.clickAction()} style={{ position: 'fixed', height: this.props.height, width: this.props.width, backgroundColor: 'white', top: this.props.top, borderTopRightRadius: this.props.border, borderBottomRightRadius: this.props.border }}>
            <div>
              {this.renderBackButton()}
            </div>
          </div>
        }
      </div>
    )
  }
}

export default MenuButtonMiami




// WEBPACK FOOTER //
// ./src/Components/Theme/Miami/MenuButtonMiami.js